export default {
  header: 'Wählen Sie',
  hint: 'Nicht alle Sensoren sind für dieses Gerät abgebildet',
};
